import axios from 'axios';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: API, withCredentials: true });

// Auth
export const changePassword = (data) => api.put('/auth/change-password', data);

// Users
export const getUsers = () => api.get('/users');
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const createUserAdmin = (data) => api.post('/users', data);
export const resetUserPassword = (id, password) => api.put(`/users/${id}/password`, { password });

// Transactions
export const getTransactions = (params) => api.get('/transactions', { params });
export const createTransaction = (data) => api.post('/transactions', data);
export const updateTransaction = (id, data) => api.put(`/transactions/${id}`, data);
export const deleteTransaction = (id) => api.delete(`/transactions/${id}`);

// Courses
export const getCourses = (params) => api.get('/courses', { params });
export const createCourse = (data) => api.post('/courses', data);
export const updateCourse = (id, data) => api.put(`/courses/${id}`, data);
export const deleteCourse = (id) => api.delete(`/courses/${id}`);

// Reservations
export const createReservation = (data) => api.post('/reservations', data);
export const createReservationBatch = (data) => api.post('/reservations/batch', data);
export const getBatchDateRange = (batch_id) => api.get(`/reservations/batch/${batch_id}/range`);
export const updateReservation = (id, data) => api.put(`/reservations/${id}`, data);
export const updateReservationAttendees = (id, actual_attendees) => api.patch(`/reservations/${id}/attendees`, { actual_attendees });
export const deleteReservation = (id) => api.delete(`/reservations/${id}`);

// Rentals
export const getRentals = (params) => api.get('/rentals', { params });
export const createRental = (data) => api.post('/rentals', data);
export const createRentalBatch = (data) => api.post('/rentals/batch', data);
export const getBatchRentalRange = (batch_id) => api.get(`/rentals/batch/${batch_id}/range`);
export const updateRental = (id, data) => api.put(`/rentals/${id}`, data);
export const deleteRental = (id) => api.delete(`/rentals/${id}`);

// Monitor
export const getCheckins = (params) => api.get('/monitor-checkins', { params });
export const createCheckin = (data) => api.post('/monitor-checkins', data);
export const getMonitorCourses = () => api.get('/monitor-courses');
export const confirmAttendance = (courseId) => api.post(`/monitor-attendance/${courseId}`);
export const cancelAttendance = (courseId) => api.delete(`/monitor-attendance/${courseId}`);
export const getMyAttendance = () => api.get('/monitor-attendance');
export const getPersonalCourses = () => api.get('/monitor-personal-courses');
export const createPersonalCourse = (data) => api.post('/monitor-personal-courses', data);
export const deletePersonalCourse = (id) => api.delete(`/monitor-personal-courses/${id}`);

// Settings
export const getSettings = () => api.get('/settings');
export const updateSettings = (data) => api.put('/settings', data);
export const getCourseCategories = () => api.get('/course-categories');
export const updateCourseCategories = (categories) => api.put('/course-categories', { categories });
export const getBizumRecipients = () => api.get('/bizum-recipients');
export const updateBizumRecipients = (recipients) => api.put('/bizum-recipients', { recipients });

// Reports
export const getBalance = (params) => api.get('/reports/balance', { params });
export const getDailyReport = (params) => api.get('/reports/daily', { params });
export const getMonitorStats = (params) => api.get('/reports/monitors', { params });
export const getMonitors = () => api.get('/monitors');

// Inventory
export const getInvCategories = () => api.get('/inventory/categories');
export const createInvCategory = (data) => api.post('/inventory/categories', data);
export const updateInvCategory = (id, data) => api.put(`/inventory/categories/${id}`, data);
export const deleteInvCategory = (id) => api.delete(`/inventory/categories/${id}`);
export const getInvItems = (params) => api.get('/inventory/items', { params });
export const createInvItem = (data) => api.post('/inventory/items', data);
export const updateInvItem = (id, data) => api.put(`/inventory/items/${id}`, data);
export const deleteInvItem = (id) => api.delete(`/inventory/items/${id}`);

// Invoices
export const getInvoices = () => api.get('/invoices');
export const createInvoice = (data) => api.post('/invoices', data);
export const updateInvoice = (id, data) => api.put(`/invoices/${id}`, data);
export const deleteInvoice = (id) => api.delete(`/invoices/${id}`);

// Payments
export const getPayments = (params) => api.get('/payments', { params });
export const markPaymentPaid = (id) => api.patch(`/payments/${id}/pay`);
export const generatePaymentCode = (id) => api.post(`/payments/${id}/generate-code`);

// Export
export const exportDashboard = (params) => api.get('/export/dashboard', { params, responseType: 'blob' });
export const exportCourses = () => api.get('/export/courses', { responseType: 'blob' });
export const exportRentals = () => api.get('/export/rentals', { responseType: 'blob' });
export const exportMonitors = () => api.get('/export/monitors', { responseType: 'blob' });
export const exportInventory = () => api.get('/export/inventory', { responseType: 'blob' });
export const exportInvoices = () => api.get('/export/invoices', { responseType: 'blob' });

// Activity chart
export const getActivityChart = (params) => api.get('/reports/activity-chart', { params });

// Monitor stat override
export const updateMonitorStat = (name, data) => api.put(`/reports/monitors/${encodeURIComponent(name)}`, data);

// Supplier invoices
export const getSupplierInvoices = () => api.get('/supplier-invoices');
export const createSupplierInvoice = (data) => api.post('/supplier-invoices', data);
export const deleteSupplierInvoice = (id) => api.delete(`/supplier-invoices/${id}`);

// Tides & Attendance
api.getTides = () => api.get('/tides');
api.importTides = (data) => api.post('/tides/import', { data });
api.uploadTidePdfs = (pdf1, pdf2, pdf3, coefPdf, year) => {
  const fd = new FormData();
  if (pdf1) fd.append('tide_pdf_1', pdf1);
  if (pdf2) fd.append('tide_pdf_2', pdf2);
  if (pdf3) fd.append('tide_pdf_3', pdf3);
  if (coefPdf) fd.append('coef_pdf', coefPdf);
  fd.append('year', year);
  return api.post('/tides/upload-pdf', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
api.getAttendance = () => api.get('/attendance');
api.toggleAttendance = (data) => api.post('/attendance/toggle', data);

export default api;
